// extracted by mini-css-extract-plugin
export default {"spotlightsImage":"c8_jY","item":"c8_fg","topSection":"c8_mt","desc":"c8_fP","scroll":"c8_mv","scrollContent":"c8_mw"};